






























































import Vue from "vue";
import {Component} from "vue-property-decorator";
import store from '../core/store'
import { Dictionary} from "../core/types";
import {Analytics} from "../core/analytics";
import {VUE_APP_COUNTRIES, VUE_APP_BRANDING, VUE_APP_ENV} from "../core/runtime";

@Component({
    components: {}
})
export default class Search extends Vue {
    tmIdOrGsText: string = '';
    country: string = 'NZ';
    language: string = 'auto';
    standard: string = '0';
    cls: string = '0';
    method: string = 'glove';
    confToTriggerFuzzy: string = "0.75";
    countries = VUE_APP_COUNTRIES ? VUE_APP_COUNTRIES.split(",") : [this.country];
    branding: string = VUE_APP_BRANDING;
    display_fuzzy_th: boolean = VUE_APP_ENV !== "prod";

    countryOptions = [           
        {text: "Australia", id: 'AU'},
        {text: "Canada", id: 'CA'},
        {text: "New Zealand", id: 'NZ'},
        {text: "United States", id: 'US'}
    ].filter(c => this.countries.length > 0 ? this.countries.indexOf(c.id) > -1 : true);

    commonStandards = [
        {text: "All", id: '0'},
        {text: "Nice", id: '1'},
        {text: "Madrid", id: '2'},
        {text: "Country-specific", id: '3'}
    ];
    standardOptions = {
        'CA': this.commonStandards,
        'AU': this.commonStandards,
        'NZ': this.commonStandards,
        'US': [
                {text: "All", id: '0'},
                {text: "Nice", id: '1'},
                {text: "Madrid", id: '2'},
                {text: "TM5", id: '5'},
                {text: "Country-specific", id: '3'}        
            ]
    };
    defaultThrsholds : Dictionary<number> = {
            'CA': 25,
            'AU': 75,
            'NZ': 75,
            'US': 75
    };
    languageOptions = {
        'CA': [
            {text: "Auto", id: 'auto'},
            {text: "English", id: 'en'},
            {text: "French", id: 'fr'}
        ],
        'AU': [
            {text: "Auto", id: 'auto'},
            {text: "English", id: 'en'}
        ],
        'NZ': [
            {text: "Auto", id: 'auto'},
            {text: "English", id: 'en'}
        ],
        'US': [
            {text: "Auto", id: 'auto'},
            {text: "English", id: 'en'}
        ]
    };
    classOptions = [
        {text: "All", id: '0'},
        {text: "Class 1", id: '1'},
        {text: "Class 2", id: '2'},
        {text: "Class 3", id: '3'},
        {text: "Class 4", id: '4'},
        {text: "Class 5", id: '5'},
        {text: "Class 6", id: '6'},
        {text: "Class 7", id: '7'},
        {text: "Class 8", id: '8'},
        {text: "Class 9", id: '9'},
        {text: "Class 10", id: '10'},
        {text: "Class 11", id: '11'},
        {text: "Class 12", id: '12'},
        {text: "Class 13", id: '13'},
        {text: "Class 14", id: '14'},
        {text: "Class 15", id: '15'},
        {text: "Class 16", id: '16'},
        {text: "Class 17", id: '17'},
        {text: "Class 18", id: '18'},
        {text: "Class 19", id: '19'},
        {text: "Class 20", id: '20'},
        {text: "Class 21", id: '21'},
        {text: "Class 22", id: '22'},
        {text: "Class 23", id: '23'},
        {text: "Class 24", id: '24'},
        {text: "Class 25", id: '25'},
        {text: "Class 26", id: '26'},
        {text: "Class 27", id: '27'},
        {text: "Class 28", id: '28'},
        {text: "Class 29", id: '29'},
        {text: "Class 30", id: '30'},
        {text: "Class 31", id: '31'},
        {text: "Class 32", id: '32'},
        {text: "Class 33", id: '33'},
        {text: "Class 34", id: '34'},
        {text: "Class 35", id: '35'},
        {text: "Class 36", id: '36'},
        {text: "Class 37", id: '37'},
        {text: "Class 38", id: '38'},
        {text: "Class 39", id: '39'},
        {text: "Class 40", id: '40'},
        {text: "Class 41", id: '41'},
        {text: "Class 42", id: '42'},
        {text: "Class 43", id: '43'},
        {text: "Class 44", id: '44'},
        {text: "Class 45", id: '45'}
    ];
    methodOptions = [
        {text: "GloVe", id: 'glove'},
        {text: "TrainedUS", id: 'us_trained'},
    ];
    confList = [
        {text: "1.00", id :"1.00"},
        {text: "0.90", id: "0.90"},
        {text: "0.85", id: "0.85"},
        {text: "0.80", id: "0.80"},
        {text: "0.75", id: "0.75"},
        {text: "0.70", id: "0.70"},
        {text: "0.65", id: "0.65"},
        {text: "0.60", id: "0.60"},
        {text: "0.55", id: "0.55"},
        {text: "0.50", id: "0.50"},
        {text: "0.45", id: "0.45"},
        {text: "0.40", id: "0.40"},
        {text: "0.35", id: "0.35"},
        {text: "0.30", id: "0.30"},
        {text: "0.25", id: "0.25"},
        {text: "0.20", id: "0.20"},                                                
        {text: "0.15", id: "0.15"},                                                
        {text: "0.10", id: "0.10"},                                                                        
        {text: "0.05", id: "0.05"},                                                            
        {text: "0.00", id: "0.00"},                                                            
    ]

    mounted() {
        if (this.countries.length === 1) {
            this.country = this.countries[0];
        }
    }

    match() {
        if (this.tmIdOrGsText.match(/^[0-9]*$/)) {
            store.state.threshold = this.defaultThrsholds[this.country];
            store.dispatchMatchForTrademark({
            tmid: this.tmIdOrGsText, country: this.country,
            language: this.language, standard: this.standard,
            gs_class: this.cls,
            confToTriggerFuzzy: this.confToTriggerFuzzy
            });
        } else {
            store.dispatchMatchForFreetext({
            text: this.tmIdOrGsText, country: this.country, 
            language: this.language, standard: this.standard,
            gs_class: this.cls,
            confToTriggerFuzzy: this.confToTriggerFuzzy
            });
            store.state.threshold = this.defaultThrsholds[this.country];
        }
        Analytics.recordEvent('match', 'term', this.tmIdOrGsText);
        Analytics.recordEvent('match', 'country', this.country);
        Analytics.recordEvent('match', 'language', this.language);
        // Analytics.recordEvent('match', 'nice', this.nice);
    }

    get hasResults() {
        return store.state.matchResult;
    }

    get loading() {
        return store.state.loading;
    }
}
